import axios from 'axios';
import classnames from 'classnames';
import _ from 'lodash';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import React from 'react';
// import { PulseLoader } from 'react-spinners';
import { TrashSvg } from 'components/SorraSvg';
import lottie from 'lottie-web';
import { useDropzone } from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';

import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';

// import CommentPopup from 'components/CommentPopup';
import Footer from 'components/Footer';

import api from 'utils/api';

import { useAppLaunch } from 'contexts/AppLaunch';
import { useFirebaseAuth } from 'contexts/FirebaseAuth';
import useRWD from 'hooks/useRWD';

const { useEffect, useState, useRef, useCallback } = React;

export default function Ingredients(props) {
  const { seo } = props;

  const { isLg } = useRWD();
  const lottieOcrRef = useRef(null);
  const { global } = useFirebaseAuth();
  const router = useRouter();
  const { query } = router;
  const { type = '' } = query;
  const { notifications, ingredientSafetyMap, ingredientFeatureMap } =
    useAppLaunch();
  // const [firstCategoryId, setFirstCategoryID] = useState(null);

  const [ingredientImage, setIngredientImage] = useState(null);
  const [isDiLoading, setIsDiLoading] = useState(false);
  const [isAiIng, setIsAiIng] = useState(false);
  const [sudanRed, setSudanRed] = useState([]);
  // const [isChecking, setIsChecking] = useState(false);
  // const [isEditing, setIsEditing] = useState(false);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  // const [deletingId, setDeletingId] = useState(null);
  // const [deletingName, setDeletingName] = useState(null);
  // const [diResult, setDiResult] = useState(null);

  const [ingredients, setIngredients] = useState([]);

  const [cosIngredients, setCosIngredients] = useState([]);

  const [ingredientsText, setIngredientsText] = useState('');
  const [ingredientProvisionSourceUrl, setIngredientProvisionSourceUrl] =
    useState('');
  const [matchProducts, setMatchProducts] = useState([]);
  // console.log({ matchProducts });

  const [errorText, setErrorText] = useState('');
  const [warnBlock, setWarnBlock] = useState('');
  const [sudanRedMatch, setSudanRedMatch] = useState(0);

  const ingredientTab = [
    { id: 0, name: '拍照上傳' },
    { id: 1, name: '手動輸入' },
  ];
  const [selectedIngredientTab, setSelectedIngredientTab] = useState(0);

  useEffect(() => {
    if ((isDiLoading || isAiIng) && lottieOcrRef.current) {
      lottie.loadAnimation({
        container: lottieOcrRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/lotties/ocr.json',
      });
    }
  }, [isDiLoading, isAiIng]);

  useEffect(() => {
    if (_.isEmpty(sudanRed) && global?.sudanStain) {
      setSudanRed(global.sudanStain);
    }
  }, [global]);

  const onIngredientsDrop = useCallback(async (acceptedFiles) => {
    const file = acceptedFiles[0];
    setIngredientImage(file);
    setErrorText('');
    setWarnBlock('');
    setSudanRedMatch(false);
    setMatchProducts([]);
  });

  const onIngredientsImageCheck = async () => {
    if (!ingredientImage) {
      return;
    }
    const formData = new FormData();
    formData.append('files.ingredient', ingredientImage);

    setIngredients([]);
    setCosIngredients([]);

    setErrorText('');
    setWarnBlock('');
    setSudanRedMatch(false);
    setMatchProducts([]);

    try {
      setIsDiLoading(true);
      const { data: result } = await axios.request({
        method: 'POST',
        // url: 'http://localhost:7071/api/upload-ingredient-image',
        url: 'https://func-imageconvert-share-eastasia.azurewebsites.net/api/upload-ingredient-image',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const {
        blobUrl,
        valueString,
        confidence,
        ingredientsArray = [],
      } = result;
      let newIngredients = (ingredientsArray || []).map((item, index) => {
        return {
          id: uuidv4(),
          name: item,
          detail: '',
          editing: false,
        };
      });
      newIngredients = _.uniqBy(newIngredients, 'name');

      if (confidence < 0.85) {
        setErrorText('未能成功辨識圖片，請稍等輸入全成份表。');
        setIngredientImage(null);
        setIngredients([]);
        setCosIngredients([]);
        setIngredientsText('');
        throw new Error('OCR confidence too low');
      }

      const { data: ingredientResult } = await api.request({
        method: 'POST',
        url: '/api/v3/parseIngredients',
        data: {
          names: ingredientsArray || [],
        },
      });
      setMatchProducts(ingredientResult.matchedProducts || []);
      setCosIngredients(ingredientResult.ingredients || []);

      let sudanCheckNum = 0;
      const sudanRedIngredients = [];
      _.map(sudanRed, (sudanItem, index) => {
        let hasMatch = false;
        _.map(ingredientResult.ingredients, (ing) => {
          if (sudanItem.includes(ing.id)) {
            sudanRedIngredients.push(ing);
            hasMatch = true;
          }
        });
        if (hasMatch) {
          sudanCheckNum |= 1 << index;
        }
      });
      const sudanRedLength = Array.isArray(sudanRed)
        ? sudanRed.length
        : Object.keys(sudanRed).length;
      const allMatched = sudanCheckNum == (1 << sudanRedLength) - 1;
      setSudanRedMatch(allMatched);
      if (allMatched) {
        setWarnBlock(
          '' +
            sudanRedIngredients
              .map((ing) => `．${ing.details} (${ing.name})`)
              .join('\n')
        );
      } else {
        setWarnBlock(
          '暫未發現與蘇丹紅事件相關的成份組合，若有疑慮，亦可進一步向廠商確認。'
        );
      }
    } catch (err) {
      setErrorText('未能成功辨識圖片，請稍等輸入全成份表。');
      setIngredientImage(null);
      setIngredients([]);
      setCosIngredients([]);
      setIngredientsText('');
    } finally {
      setIsDiLoading(false);
    }
  };

  const {
    getRootProps: getIngredientsRootProps,
    getInputProps: getIngredientsInputProps,
  } = useDropzone({
    onDrop: onIngredientsDrop,
    accept: {
      'image/*': ['.jpg', '.jpeg', '.png', '.heic'],
    },
    maxFiles: 1,
  });

  const handleSorraIngredientTab = async (field, id, featureData = null) => {};

  const [isDragging, setIsDragging] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [sudanInfo, setSudanInfo] = useState(false);

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);

    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  }, []);

  function formatFileSize(bytes) {
    if (bytes < 1024) {
      return `${bytes} B`;
    } else if (bytes < 1024 * 1024) {
      return `${(bytes / 1024).toFixed(2)} b`;
    } else if (bytes < 1024 * 1024 * 1024) {
      return `${(bytes / (1024 * 1024)).toFixed(2)}mb`;
    } else {
      return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)}gb`;
    }
  }

  useEffect(() => {
    if (!_.isEmpty(cosIngredients)) {
      setTimeout(() => {
        document.getElementById('ai-result')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    }
  }, [cosIngredients]);
  //   useEffect(() => {
  //     if (categoryTree.length > 0) {
  //       setFirstCategoryID(categoryTree[0].id);
  //     }
  //   }, [categoryTree]);

  // const [isCommentModalShow, setIsCommentModalShow] = useState(false);

  // const [ingredientsText, setIngredientsText] = useState('');

  return (
    <div
      style={
        isLg
          ? {}
          : {
              background: `${type != '' ? '#FFFFFF' : '#FFF8F8'}`,
              // 'linear-gradient(91deg, #FFF4E7 40.8%, #FFEAEA 100.11%)',
            }
      }
    >
      <NextSeo
        title={seo.title}
        description={seo.description}
        canonical="https://www.sorra.net/ingredients"
      />
      <main>
        <Menubar
          props={{
            homeExtend: false,
            sourceUI: 'Ranking',
          }}
        />
        <div
          className={
            'globals-centerContentsMargin relative ' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
          //   style={{ backgroundImage: 'url(/images/bg-ranking.png)' }}
        >
          {/* <ToastContainer
            position={isLg ? 'top-right' : 'bottom-center'}
            className="absolute !bottom-24 top-[unset] w-[unset] !px-4 lg:!fixed lg:!top-[170px] lg:bottom-[unset] lg:!w-auto lg:px-[unset]"
            toastClassName="!min-h-[47px] !rounded-full"
            bodyClassName="!text-sm !text-gray-800"
            closeButton={false}
            autoClose={3000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            theme="light"
          /> */}
          <div
            className="relative w-full overflow-hidden pb-10 lg:h-[430px] lg:pb-0"
            style={{
              background: `${type != '' ? '#FFFFFF' : '#FFF8F8'}`,
              // 'linear-gradient(91deg, #FFF4E7 40.8%, #FFEAEA 100.11%)',
            }}
          >
            <img
              src={`${isLg ? '/images/bg-sudan-ingredients.png' : '/images/bg-sudan-ingredients-mobile.png'}`}
              className={`${type != '' ? '' : 'hidden'} absolute -right-[0%] -top-[10%] z-0 h-auto w-[1440px] lg:right-0 lg:top-0 lg:object-cover`}
            />

            {/* 文字內容 */}
            <MaxWidthContainer
              className={`lg:pb-18 relative z-10 flex h-full flex-col items-start px-4 pt-4 lg:px-0 ${type != '' ? 'lg:pt-[78px]' : 'lg:pt-[0px]'}`}
            >
              <p
                className={`text-[30px] font-bold lg:pt-6 lg:text-[48px] ${type != '' ? 'hidden' : ''}`}
              >
                AI成份分析
              </p>
              <p
                className={`lg:pt-17 text-[30px] font-bold text-sorra-pink lg:text-[48px] ${type != '' ? '' : 'hidden'}`}
              >
                蘇丹紅成份檢測
              </p>
              <h1 className={`hidden`}>
                {type != '' ? '蘇丹紅化妝品成份檢測' : 'AI成份分析'}
              </h1>
              <h2 className={`hidden`}>
                {type != '' ? '1 秒分析成分安全性' : ''}
              </h2>
              <span
                className={`${type != '' ? '' : 'hidden'} z-10 py-2 text-base font-medium`}
              >
                擔心化妝品/護膚品含致癌「蘇丹紅」？
                <br className="hidden lg:block" />
                即用 Sorra蘇丹紅檢測工具，上傳照片即可透過 AI排查成分風險，
                <br className="hidden lg:block" />
                助你遠離有害物質，安心護膚。
              </span>
              <span
                className={`${type != '' ? '' : 'hidden'} cursor-pointer pb-2 text-sm font-medium text-sorra-pink`}
                onClick={() => setSudanInfo(!sudanInfo)}
              >
                <img
                  src="/svgs/information-circle-pink.svg"
                  alt=""
                  className="mr-1 inline-block h-4 w-4"
                />
                什麼是蘇丹紅？
              </span>
              <span
                className={`rounded-lg bg-[#F5F5F5] px-3 py-2 text-sm ${sudanInfo ? '' : 'hidden'} lg:w-[500px]`}
              >
                蘇丹紅是一類非法工業染料，禁止用於食品及化妝品中。部分成份名稱或別名可能與相關事件有關，需進一步確認來源及檢測結果。
              </span>
            </MaxWidthContainer>

            <div
              className={`${type != '' ? '' : 'hidden'} z-9 relative right-[40px] top-[10px] lg:absolute lg:right-[10%] lg:top-[20%] lg:px-0 lg:pb-0`}
            >
              <img
                src={`/images/bg-sudan-step${isLg ? '' : '-mobile'}.png`}
                className="h-auto w-[600px] lg:w-[750px] lg:object-contain"
              />
            </div>

            <MaxWidthContainer noPending className="relative bg-[#FFF8F8]">
              <div
                className={`${type != '' ? 'hidden' : ''} relative z-20 pb-0 pt-0 lg:pb-[76px]`}
              >
                <img
                  src="/images/bg-ingredients.png"
                  className={`${type != '' ? 'hidden' : ''} h-auto w-full object-contain opacity-0 lg:absolute lg:bottom-[200%] lg:ml-0 lg:h-[200px] lg:w-[723px] lg:opacity-100`}
                />
              </div>
              <img
                src="/images/bg-scan-ingredients.png"
                className={`${type != '' ? 'hidden' : ''} absolute -bottom-10 -right-[62px] z-10 w-[300px] object-contain lg:bottom-[170%] lg:right-0 lg:w-[632px]`}
              />
            </MaxWidthContainer>

            <div
              className={`${type != '' ? 'hidden' : ''} absolute relative right-[40px] top-[10px] z-10 lg:right-[10%] lg:top-[20%] lg:px-0 lg:pb-0`}
            >
              <img
                src="/images/bg-ingredients-mobile.png"
                className="h-auto w-[600px] lg:w-[750px] lg:object-contain"
              />
            </div>
          </div>

          <MaxWidthContainer className="relative z-20 -mt-5 px-4 lg:-mt-14 lg:px-20">
            <div className="rounded-2xl border border-gray-100 bg-white p-3 shadow-lg lg:p-6">
              <div className="w-full">
                <p className="font-bold lg:text-[24px]">
                  上傳產品成份表照片或手動輸入內容
                </p>

                <div className="no-scrollbar mt-6 flex w-full flex-row gap-x-8 overflow-x-auto">
                  {ingredientTab &&
                    ingredientTab.map((tab, idx) => {
                      return (
                        <div
                          key={tab.id}
                          className="flex shrink-0 cursor-pointer flex-col gap-y-4"
                          onClick={() => {
                            setSelectedIngredientTab(idx);
                            handleSorraIngredientTab(
                              'sorra_featureds',
                              tab.id,
                              ''
                            );
                          }}
                        >
                          <div className="flex flex-row">
                            {tab.id === 0 ? (
                              <div className="h-5 w-5">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="100%"
                                  height="100%"
                                  viewBox="0 0 21 21"
                                  fill="none"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M4.5 5.27344C3.96957 5.27344 3.46086 5.48415 3.08579 5.85922C2.71071 6.2343 2.5 6.743 2.5 7.27344V15.2734C2.5 15.8039 2.71071 16.3126 3.08579 16.6877C3.46086 17.0627 3.96957 17.2734 4.5 17.2734H16.5C17.0304 17.2734 17.5391 17.0627 17.9142 16.6877C18.2893 16.3126 18.5 15.8039 18.5 15.2734V7.27344C18.5 6.743 18.2893 6.2343 17.9142 5.85922C17.5391 5.48415 17.0304 5.27344 16.5 5.27344H14.914C14.6488 5.27338 14.3945 5.16799 14.207 4.98044L13.086 3.85944C12.711 3.48434 12.2024 3.27355 11.672 3.27344H9.328C8.79761 3.27355 8.28899 3.48434 7.914 3.85944L6.793 4.98044C6.60551 5.16799 6.35119 5.27338 6.086 5.27344H4.5ZM10.5 14.2734C10.894 14.2734 11.2841 14.1958 11.6481 14.0451C12.012 13.8943 12.3427 13.6733 12.6213 13.3948C12.8999 13.1162 13.1209 12.7855 13.2716 12.4215C13.4224 12.0575 13.5 11.6674 13.5 11.2734C13.5 10.8795 13.4224 10.4894 13.2716 10.1254C13.1209 9.76141 12.8999 9.43069 12.6213 9.15212C12.3427 8.87354 12.012 8.65256 11.6481 8.5018C11.2841 8.35103 10.894 8.27344 10.5 8.27344C9.70435 8.27344 8.94129 8.58951 8.37868 9.15212C7.81607 9.71473 7.5 10.4778 7.5 11.2734C7.5 12.0691 7.81607 12.8321 8.37868 13.3948C8.94129 13.9574 9.70435 14.2734 10.5 14.2734Z"
                                    fill={
                                      tab.id === selectedIngredientTab
                                        ? '#F16B7C'
                                        : '#4A4A4A'
                                    }
                                  />
                                </svg>
                              </div>
                            ) : (
                              <div className="h-5 w-5">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                >
                                  <path
                                    d="M13.586 3.58616C13.7705 3.39514 13.9912 3.24278 14.2352 3.13796C14.4792 3.03314 14.7416 2.97797 15.0072 2.97566C15.2728 2.97335 15.5361 3.02396 15.7819 3.12452C16.0277 3.22508 16.251 3.37359 16.4388 3.56137C16.6266 3.74916 16.7751 3.97246 16.8756 4.21825C16.9762 4.46405 17.0268 4.72741 17.0245 4.99296C17.0222 5.25852 16.967 5.52096 16.8622 5.76497C16.7574 6.00898 16.605 6.22967 16.414 6.41416L15.621 7.20716L12.793 4.37916L13.586 3.58616ZM11.379 5.79316L3 14.1722V17.0002H5.828L14.208 8.62116L11.378 5.79316H11.379Z"
                                    fill={
                                      tab.id === selectedIngredientTab
                                        ? '#F16B7C'
                                        : '#4A4A4A'
                                    }
                                  />
                                </svg>
                              </div>
                            )}
                            <span
                              className={classnames(
                                'pl-2 text-base lg:text-[20px]',
                                idx === selectedIngredientTab
                                  ? 'font-bold text-[#111928]'
                                  : 'font-normal text-[#4a4a4a]'
                              )}
                            >
                              {tab.name}
                            </span>
                          </div>
                          <div
                            className={classnames(
                              'h-[3px] rounded-full',
                              idx === selectedIngredientTab
                                ? 'bg-sorra-pink'
                                : 'bg-transparent'
                            )}
                          />
                        </div>
                      );
                    })}
                </div>

                <div className="h-px w-full bg-gray-100"></div>
                <div className="mt-6 w-full">
                  {isDiLoading || isAiIng ? (
                    <div className="flex h-[200px] items-center justify-center rounded-lg bg-white">
                      <div
                        ref={lottieOcrRef}
                        className="h-[38px] w-[38px]"
                      ></div>
                      <p className="font-medium text-gray-800">
                        AI智能分析中...
                      </p>
                    </div>
                  ) : selectedIngredientTab == 1 ? (
                    <textarea
                      placeholder="請輸入成份列表"
                      value={ingredientsText}
                      onChange={(e) => {
                        setIngredientsText(e.target.value);
                      }}
                      className="h-[200px] w-full rounded-lg border border-[#9B9B9B] bg-white p-4 text-gray-900 outline-none placeholder:text-gray-500 focus:outline-none focus:ring-0"
                    />
                  ) : !ingredientImage && selectedIngredientTab == 0 ? (
                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      className="flex h-[200px] flex-col items-center justify-center rounded-lg bg-white bg-contain bg-center bg-no-repeat p-4"
                      style={{
                        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23000000' stroke-width='1' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
                      }}
                    >
                      <img
                        src="/svgs/image-upload.svg"
                        className="mb-4 h-[60px] w-[60px] object-contain"
                      ></img>
                      <p className="text-center text-[16px]">
                        拖放圖片或{' '}
                        <span
                          className="cursor-pointer text-sorra-pink underline"
                          {...getIngredientsRootProps()}
                        >
                          瀏覽本地文件
                        </span>{' '}
                        即可上傳
                      </p>
                    </div>
                  ) : (
                    <div
                      className="flex h-[172px] w-full flex-col items-center justify-center rounded-lg bg-white py-2.5 lg:h-[200px] lg:flex-row"
                      style={{
                        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23000000' stroke-width='1' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
                      }}
                    >
                      <img
                        className="aspect-square h-[86px] w-[86px] rounded-sm object-cover lg:h-[152px] lg:w-[152px]"
                        src={URL.createObjectURL(ingredientImage)}
                      ></img>
                      <div className="flex w-full flex-row items-center justify-between px-4 pt-2 lg:w-[310px]">
                        <div className="flex flex-col justify-center">
                          <p className="text-xl">{ingredientImage.name}</p>
                          {/* 取到小數2位 */}
                          <p className="text-base text-sorra-gray-800">
                            {formatFileSize(ingredientImage.size)}
                          </p>
                        </div>
                        <div className="flex cursor-pointer lg:items-center lg:justify-center lg:pl-[119px]">
                          <div
                            className="h-6 w-6 lg:h-5 lg:w-5"
                            onClick={() => {
                              setIngredientImage(null);
                              setIngredients([]);
                              setCosIngredients([]);
                              setIngredientsText('');
                            }}
                          >
                            <TrashSvg color="#4A4A4A" />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {!_.isEmpty(errorText) && (
                <div className="mt-6 flex items-center justify-start gap-x-2">
                  <div className="h-5 w-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <path
                        d="M10.7383 6.9401V10.2734M10.7383 13.6068H10.7466M18.2383 10.2734C18.2383 11.2584 18.0443 12.2336 17.6674 13.1436C17.2905 14.0535 16.738 14.8803 16.0416 15.5767C15.3451 16.2732 14.5183 16.8256 13.6084 17.2025C12.6985 17.5794 11.7232 17.7734 10.7383 17.7734C9.75337 17.7734 8.7781 17.5794 7.86816 17.2025C6.95821 16.8256 6.13142 16.2732 5.43498 15.5767C4.73854 14.8803 4.18609 14.0535 3.80918 13.1436C3.43227 12.2336 3.23828 11.2584 3.23828 10.2734C3.23828 8.28431 4.02846 6.37666 5.43498 4.97014C6.8415 3.56361 8.74916 2.77344 10.7383 2.77344C12.7274 2.77344 14.6351 3.56361 16.0416 4.97014C17.4481 6.37666 18.2383 8.28431 18.2383 10.2734Z"
                        stroke="#F94C00"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <p className="text-base text-[#F94C00]">{errorText}</p>
                </div>
              )}
              <input {...getIngredientsInputProps()} />
              <div className="mt-6 flex flex-col gap-x-4 gap-y-3 lg:flex-row">
                {!ingredientImage && (
                  <button
                    disabled={_.isEmpty(ingredientsText) || isAiIng}
                    className="flex h-12 flex-auto shrink-0 items-center justify-center gap-x-4 rounded-lg bg-sorra-pink text-white disabled:opacity-50 lg:flex-1"
                    onClick={async () => {
                      let arrayData = [];
                      setIngredients([]);
                      setCosIngredients([]);

                      setErrorText('');
                      setWarnBlock('');
                      setSudanRedMatch(false);
                      setMatchProducts([]);
                      setIsAiIng(true);
                      try {
                        const { data } = await axios.request({
                          method: 'POST',
                          // url: 'http://localhost:7071/api/analyze-ingredient-text',
                          url: 'https://func-imageconvert-share-eastasia.azurewebsites.net/api/analyze-ingredient-text',
                          data: {
                            text: ingredientsText,
                          },
                        });
                        arrayData = _.uniq(data.ingredientsArray || []).map(
                          (item, index) => {
                            return {
                              id: uuidv4(),
                              name: item,
                              detail: '',
                              editing: false,
                            };
                          }
                        );
                        if (arrayData.length < 5) {
                          setErrorText(
                            '無效成份表（成份過少），需展示整個成份表。'
                          );
                          setIsAiIng(false);
                          return;
                        }
                        const { data: ingredientResult } = await api.request({
                          method: 'POST',
                          url: '/api/v3/parseIngredients',
                          data: {
                            names: data.ingredientsArray || [],
                          },
                        });
                        setMatchProducts(
                          ingredientResult.matchedProducts || []
                        );
                        setCosIngredients(ingredientResult.ingredients || []);

                        let sudanCheckNum = 0;
                        const sudanRedIngredients = [];
                        _.map(sudanRed, (sudanItem, index) => {
                          let hasMatch = false;
                          _.map(ingredientResult.ingredients, (ing) => {
                            if (sudanItem.includes(ing.id)) {
                              sudanRedIngredients.push(ing);
                              hasMatch = true;
                            }
                          });
                          if (hasMatch) {
                            sudanCheckNum |= 1 << index;
                          }
                        });
                        const sudanRedLength = Array.isArray(sudanRed)
                          ? sudanRed.length
                          : Object.keys(sudanRed).length;
                        const allMatched =
                          sudanCheckNum == (1 << sudanRedLength) - 1;
                        setSudanRedMatch(allMatched);
                        if (allMatched) {
                          setWarnBlock(
                            '' +
                              sudanRedIngredients
                                .map((ing) => `．${ing.details} (${ing.name})`)
                                .join('\n')
                          );
                        } else {
                          setWarnBlock(
                            '暫未發現與蘇丹紅事件相關的成份組合，若有疑慮，亦可進一步向廠商確認。'
                          );
                        }
                      } catch (err) {
                        setErrorText('未能成功辨識，請輸入正確全成份表。');
                      } finally {
                        setIsAiIng(false);
                      }
                    }}
                  >
                    <div className="h-5 w-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100%"
                        height="100%"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.5 4.27347C7.43913 4.27347 6.42172 4.6949 5.67157 5.44504C4.92143 6.19519 4.5 7.21261 4.5 8.27347C4.5 9.33434 4.92143 10.3518 5.67157 11.1019C6.42172 11.852 7.43913 12.2735 8.5 12.2735C9.56087 12.2735 10.5783 11.852 11.3284 11.1019C12.0786 10.3518 12.5 9.33434 12.5 8.27347C12.5 7.21261 12.0786 6.19519 11.3284 5.44504C10.5783 4.6949 9.56087 4.27347 8.5 4.27347ZM2.5 8.27347C2.49988 7.32918 2.72264 6.39818 3.15017 5.55621C3.5777 4.71424 4.19792 3.98507 4.9604 3.428C5.72287 2.87092 6.60606 2.50168 7.53815 2.3503C8.47023 2.19893 9.42488 2.26968 10.3245 2.55682C11.224 2.84396 12.0432 3.33937 12.7152 4.00277C13.3872 4.66616 13.8931 5.4788 14.1919 6.3746C14.4906 7.2704 14.5737 8.22406 14.4343 9.15802C14.295 10.092 13.9372 10.9799 13.39 11.7495L18.207 16.5665C18.3892 16.7551 18.49 17.0077 18.4877 17.2699C18.4854 17.5321 18.3802 17.7829 18.1948 17.9683C18.0094 18.1537 17.7586 18.2589 17.4964 18.2611C17.2342 18.2634 16.9816 18.1626 16.793 17.9805L11.977 13.1645C11.0794 13.8028 10.0233 14.1816 8.92468 14.2596C7.826 14.3375 6.72707 14.1116 5.7483 13.6064C4.76953 13.1013 3.94869 12.3365 3.37572 11.3958C2.80276 10.4551 2.49979 9.37491 2.5 8.27347Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <p>成份查詢</p>
                  </button>
                )}
                {ingredientImage && (
                  <button
                    className="flex h-12 flex-auto shrink-0 items-center justify-center gap-x-4 rounded-lg bg-sorra-pink text-white lg:flex-1"
                    onClick={onIngredientsImageCheck}
                  >
                    <div className="h-5 w-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100%"
                        height="100%"
                        viewBox="0 0 21 21"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.5 4.27347C7.43913 4.27347 6.42172 4.6949 5.67157 5.44504C4.92143 6.19519 4.5 7.21261 4.5 8.27347C4.5 9.33434 4.92143 10.3518 5.67157 11.1019C6.42172 11.852 7.43913 12.2735 8.5 12.2735C9.56087 12.2735 10.5783 11.852 11.3284 11.1019C12.0786 10.3518 12.5 9.33434 12.5 8.27347C12.5 7.21261 12.0786 6.19519 11.3284 5.44504C10.5783 4.6949 9.56087 4.27347 8.5 4.27347ZM2.5 8.27347C2.49988 7.32918 2.72264 6.39818 3.15017 5.55621C3.5777 4.71424 4.19792 3.98507 4.9604 3.428C5.72287 2.87092 6.60606 2.50168 7.53815 2.3503C8.47023 2.19893 9.42488 2.26968 10.3245 2.55682C11.224 2.84396 12.0432 3.33937 12.7152 4.00277C13.3872 4.66616 13.8931 5.4788 14.1919 6.3746C14.4906 7.2704 14.5737 8.22406 14.4343 9.15802C14.295 10.092 13.9372 10.9799 13.39 11.7495L18.207 16.5665C18.3892 16.7551 18.49 17.0077 18.4877 17.2699C18.4854 17.5321 18.3802 17.7829 18.1948 17.9683C18.0094 18.1537 17.7586 18.2589 17.4964 18.2611C17.2342 18.2634 16.9816 18.1626 16.793 17.9805L11.977 13.1645C11.0794 13.8028 10.0233 14.1816 8.92468 14.2596C7.826 14.3375 6.72707 14.1116 5.7483 13.6064C4.76953 13.1013 3.94869 12.3365 3.37572 11.3958C2.80276 10.4551 2.49979 9.37491 2.5 8.27347Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <p>成份查詢</p>
                  </button>
                )}
              </div>
            </div>
          </MaxWidthContainer>
          {!_.isEmpty(cosIngredients) && (
            <MaxWidthContainer className="px-4 pt-8 lg:px-0 lg:pt-10">
              <div
                id="ai-result"
                className="scroll-mt-[65px] rounded-2xl border border-gray-100 bg-white px-6 pt-6 shadow-lg lg:scroll-mt-[104px] lg:px-6 lg:pt-0"
              >
                <div className="lg:mt-6 lg:px-0">
                  <p className="text-xl font-bold lg:text-2xl">
                    成份分析結果({`${cosIngredients.length}`})
                  </p>
                </div>
                {!_.isEmpty(warnBlock) && (
                  <div
                    className={`items-left mt-2 flex flex-col justify-start gap-x-2 rounded-lg ${sudanRedMatch ? 'bg-[#FDE8E8]' : 'bg-[#DEF7EC]'} p-4 lg:mt-6`}
                  >
                    {sudanRedMatch ? (
                      <>
                        <div className="flex flex-row items-center gap-x-2">
                          <svg
                            width={`${isLg ? 20 : 18}`}
                            height={`${isLg ? 20 : 18}`}
                            viewBox={`0 0 ${isLg ? 22 : 20} ${isLg ? 22 : 20}`}
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="mt-1 shrink-0"
                          >
                            <path
                              d="M10 3L18 16.5C18.3 17 18 17.5 17.5 17.5H2.5C2 17.5 1.7 17 2 16.5L10 3Z"
                              fill="#DC2626"
                              stroke="#DC2626"
                              strokeWidth="3.5"
                              strokeLinejoin="round"
                              strokeLinecap="round"
                            />
                            <circle cx="10" cy="14" r="1.2" fill="white" />
                            <rect
                              x="9"
                              y="7"
                              width="2"
                              height="4"
                              rx="1"
                              fill="white"
                            />
                          </svg>
                          <p className="text-[16px] font-semibold text-[#C81E1E] lg:text-lg">
                            發現可能與蘇丹紅事件相關的成份組合,
                            建議進一步向廠商確認:
                          </p>
                        </div>
                        <p className="whitespace-pre-wrap pt-2 text-base font-semibold text-[#C81E1E]">
                          {warnBlock}
                        </p>
                      </>
                    ) : (
                      <div className="flex flex-row items-center gap-x-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={`${isLg ? 20 : 18}`}
                          height={`${isLg ? 20 : 18}`}
                          viewBox="0 0 20 20"
                          fill="none"
                          className="mt-1 shrink-0"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M2.4 0C1.76348 0 1.15303 0.252856 0.702944 0.702944C0.252856 1.15303 0 1.76348 0 2.4V15.6C0 16.5548 0.379285 17.4705 1.05442 18.1456C1.72955 18.8207 2.64522 19.2 3.6 19.2C4.55478 19.2 5.47045 18.8207 6.14558 18.1456C6.82072 17.4705 7.2 16.5548 7.2 15.6V2.4C7.2 1.76348 6.94714 1.15303 6.49706 0.702944C6.04697 0.252856 5.43652 0 4.8 0H2.4ZM3.6 16.8C3.91826 16.8 4.22348 16.6736 4.44853 16.4485C4.67357 16.2235 4.8 15.9183 4.8 15.6C4.8 15.2817 4.67357 14.9765 4.44853 14.7515C4.22348 14.5264 3.91826 14.4 3.6 14.4C3.28174 14.4 2.97652 14.5264 2.75147 14.7515C2.52643 14.9765 2.4 15.2817 2.4 15.6C2.4 15.9183 2.52643 16.2235 2.75147 16.4485C2.97652 16.6736 3.28174 16.8 3.6 16.8ZM9.6 14.6916L15.48 8.8116C15.9299 8.36153 16.1827 7.75119 16.1827 7.1148C16.1827 6.47841 15.9299 5.86807 15.48 5.418L13.782 3.72C13.3319 3.27007 12.7216 3.01731 12.0852 3.01731C11.4488 3.01731 10.8385 3.27007 10.3884 3.72L9.6 4.5084V14.6916ZM16.8 19.2H8.4852L15.6852 12H16.8C17.4365 12 18.047 12.2529 18.4971 12.7029C18.9471 13.153 19.2 13.7635 19.2 14.4V16.8C19.2 17.4365 18.9471 18.047 18.4971 18.4971C18.047 18.9471 17.4365 19.2 16.8 19.2V19.2Z"
                            fill="#046C4E"
                          />
                        </svg>
                        <p className="text-[16px] font-semibold text-[#046C4E] lg:text-lg">
                          {warnBlock}
                        </p>
                      </div>
                    )}
                  </div>
                )}
                <div className="block lg:hidden">
                  {cosIngredients.map((item, idx) => {
                    const { name, details, features } = item;
                    const safety = ingredientSafetyMap[item.safety];
                    const safetyName = safety ? safety.name : '-';
                    // const features = _.compact(
                    //   _.map(ingredient_features, (ifId) => {
                    //     return (
                    //       ingredientFeatureMap[ifId] &&
                    //       ingredientFeatureMap[ifId].name
                    //     );
                    //   })
                    // );

                    return (
                      <div
                        key={name}
                        className="mt-3 flex flex-col gap-y-2 p-2 text-sm"
                      >
                        <div className="flex justify-between gap-x-8">
                          <p className="shrink-0">含量</p>
                          <p>#{idx + 1}</p>
                        </div>
                        <div className="flex justify-between gap-x-8">
                          <p className="shrink-0">成份名稱</p>
                          <p>{name || '-'}</p>
                        </div>
                        <div className="flex w-full items-start justify-between gap-x-8 overflow-hidden">
                          <p className="shrink-0">中文名稱</p>
                          <p className="break-all text-right">
                            {details || '-'}
                          </p>
                        </div>
                        <div className="flex justify-between gap-x-8">
                          <p className="shrink-0">安全性</p>
                          <div className="flex items-center justify-between">
                            {safety ? (
                              <div
                                style={{ background: safety?.tag_color }}
                                className={`mr-[8px] h-[8px] w-[8px] rounded-[50%]`}
                              />
                            ) : null}
                            <div>{safetyName}</div>
                          </div>
                        </div>
                        <div className="flex w-full items-start justify-between gap-x-8 overflow-hidden pb-1">
                          <p className="shrink-0">一般用途</p>
                          <div className="flex flex-wrap justify-end gap-x-1 gap-y-1">
                            {features.map((feature) => {
                              return (
                                <div
                                  key={feature}
                                  className="h-6 rounded-full bg-[#E7E7E7] px-1.5 text-[14px] text-[#76777B]"
                                >
                                  {feature}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className="h-px w-full bg-gray-100"></div>
                      </div>
                    );
                  })}
                  <p className="px-2 pb-6 text-[14px] text-sorra-gray-500">
                    本 AI
                    檢測功能根據公開資料與關鍵字比對進行分析，結果僅供參考，如對產品安全性有疑慮，建議向品牌或廠商索取正式第三方檢測報告。
                  </p>
                </div>
                <div className="mt-6 hidden lg:block">
                  <div className="grid grid-cols-12 gap-4 rounded-[8px] bg-[#4A4A4A] p-[16px] text-[16px] font-[400] text-[#fff] lg:w-full">
                    <div className="col-span-1">含量</div>
                    <div className="col-span-3">成份名稱</div>
                    <div className="col-span-3">成份中文名稱</div>
                    <div className="col-span-2">安全性</div>
                    <div className="col-span-3">一般用途</div>
                  </div>
                  {cosIngredients.map((item, index) => {
                    const { name, details, features } = item;
                    // const { ingredient_safety, ingredient_features } = item;
                    const safety = ingredientSafetyMap[item.safety];
                    const safetyName = safety ? safety.name : '-';
                    // const features = _.compact(
                    //   _.map(ingredient_features, (ifId) => {
                    //     return (
                    //       ingredientFeatureMap[ifId] &&
                    //       ingredientFeatureMap[ifId].name
                    //     );
                    //   })
                    // );

                    return (
                      <div
                        key={name}
                        className="grid grid-cols-12 items-center gap-4 px-[16px] py-[24px] odd:bg-[#F5F5F5]"
                      >
                        <div className="col-span-1">#{index + 1}</div>
                        <div className="col-span-3 break-words">
                          {name || '-'}
                        </div>
                        <div className="col-span-3 break-words">
                          {details || '-'}
                        </div>
                        <div className="col-span-2 flex flex-wrap items-center">
                          {safety ? (
                            <div
                              style={{ background: safety?.tag_color }}
                              className={`mr-[8px] h-[8px] w-[8px] rounded-[50%]`}
                            />
                          ) : null}
                          <div>{safetyName}</div>
                        </div>
                        <div className="col-span-3 flex flex-wrap items-center gap-2">
                          {features.map((feature) => {
                            return (
                              <div
                                key={feature}
                                className="rounded-[100px] bg-[#E7E7E7] px-[10px] py-[4px] text-[14px] text-[#76777B]"
                              >
                                {feature}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                  <p className="py-6 text-sorra-gray-500">
                    本 AI
                    檢測功能根據公開資料與關鍵字比對進行分析，結果僅供參考，如對產品安全性有疑慮，建議向品牌或廠商索取正式第三方檢測報告。
                  </p>
                </div>
              </div>
              {!_.isEmpty(matchProducts) && (
                <div className="mt-9 px-4 lg:px-0">
                  <p className="text-xl font-bold lg:text-2xl">
                    搜索到相同成份產品
                  </p>
                </div>
              )}
              {!_.isEmpty(matchProducts) && (
                <div className="mt-4 grid grid-cols-1 gap-x-4 gap-y-4 px-4 lg:grid-cols-3 lg:px-0">
                  {matchProducts.map((p, idx) => {
                    const images = p.images || [];
                    return (
                      <div
                        key={p.id}
                        className="flex cursor-pointer items-center gap-x-3 rounded-[10px] border border-[#E7E7E7] bg-white px-4 py-2.5"
                        onClick={() => {
                          router.push(`/product/${p.id}`);
                        }}
                      >
                        <img
                          className="h-[64px] w-[64px] rounded object-contain"
                          src={
                            _.head(images)
                              ? _.head(images).url
                              : 'images/placeholders/product.png'
                          }
                        ></img>
                        <div className="flex flex-col justify-between text-xs text-[#111928]">
                          <p className="text-xs font-normal text-[#4a4a4a]">
                            {p.brand ? p.brand.name : ''}
                          </p>
                          <p className="text-sm font-medium">{p.en_name}</p>
                          <p className="text-sm font-medium">{p.name}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </MaxWidthContainer>
          )}
        </div>

        {/*<div className="bg-[#FBFBFB] pt-[24px] lg:pt-[34px]">
           <MaxWidthContainer className="grid grid-cols-1 gap-x-6 gap-y-[28px] p-4 lg:grid-cols-2">
            {!_.isNil(firstCategoryId) &&
              firstCategoryMap[firstCategoryId] &&
              firstCategoryMap[firstCategoryId].second_categories.map(
                (secondCategory) => {
                  const { id, name, image, rating_updated_at } = secondCategory;
                  const searchQuery = qs.stringify(
                    {
                      category: name,
                      categoryID: id,
                    },
                    { skipNulls: true }
                  );
                  const searchURL = `/search?${searchQuery}`;

                  return (
                    <button
                      key={id}
                      onClick={() => {
                        router.push(searchURL);
                      }}
                      className="flex h-[96px] items-center rounded-lg bg-[#f5f5f580] px-[16px] py-[16px] transition-all hover:bg-[#F5F5F5] lg:h-[224px] lg:px-[32px] lg:py-[32px]"
                    >
                      <img
                        className="aspect-[1/1] h-full"
                        src={
                          image ? image.url : 'images/placeholders/product.png'
                        }
                      ></img>
                      <div className="grow pl-[32px]">
                        <div className="text-xl font-bold text-sorra-gray-900 lg:text-4xl">
                          {name + '組'}
                        </div>
                      </div>
                    </button>
                  );
                }
              )}
          </MaxWidthContainer> 
        </div>*/}

        {/* <div className="pt-6 lg:pt-24"></div> */}

        {/* <CommentPopup
          externalPopupShown={isCommentModalShow}
          externalProductID={null}
          externalProductBrandName={null}
          externalProductName={null}
          setExternalPopupShown={setIsCommentModalShow}
        /> */}

        <Footer />

        <MobileTabBar props={{}} />
      </main>
    </div>
  );
}

export async function getServerSideProps(ctx) {
  const { type = '' } = ctx.query;
  // const router = useRouter();
  // const { query } = router;
  // const { type = '' } = query;
  return {
    props: {
      seo: {
        title: `${type != '' ? '【蘇丹紅檢測工具】化妝品/護膚品成分一鍵分析：即查蘇丹紅名單' : 'AI成份分析｜免費美妝護膚品成份報告 | Sorra 香港'}`,
        description: `${type != '' ? '擔心化妝品含有致癌蘇丹紅？即用 Sorra 蘇丹紅成份檢測工具，只需上傳產品成份表照片或手動輸入，AI 即時分析產品安全性。提供蘇丹紅化妝品名單查詢及避雷建議，守護你的肌膚健康！' : 'Sorra結合先進AI技術，提供免費的美妝護膚品成份分析報告，助你輕鬆了解產品成份的功效與安全性，選擇最適合自己的產品！'}`,
      },
    },
  };
}
